import { ObjectModel } from 'objectmodel';

const _App = new ObjectModel({
  category: Number,
  default_locale: String,
  description: String,
  icons: Object,
  id: String,
  installed: Boolean,
  locales: Object,
  manifest_url: String,
  name: String,
  paid: Boolean,
  version: String
}).defaultTo({
  default_locale: 'en-US'
});

const _DOMError = new ObjectModel({
  message: [String],
  name: String,
}).defaultTo({
  message: ''
});

const BookmarkApp = _App
  .extend({
    type: ['bookmark'],
    url: String
  })
  .defaultTo({
    type: 'bookmark'
  });

const NormalApp = _App.extend({
  type: ['certified', 'hosted', 'privileged'],
  downloading: Boolean,
  installed: Boolean,
  paid: Boolean,
  progress: Number,
  updatable: Boolean
});

const Bookmark = new ObjectModel({
  url: String,
  icon: String,
  name: String
}).defaultTo({
  type: 'bookmark'
});

const MozApp = new ObjectModel({
  downloadError: [_DOMError],
  downloadSize: Number,
  downloading: [Boolean],
  installState: String,
  manifest: [Object],
  manifestURL: String,
  progress: [Number],
  removable: Boolean,
  updateManifest: [Object],
});

export { BookmarkApp, NormalApp, Bookmark, MozApp };
